<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light" @keyup.enter="load">
                <b-row class="my-3 align-items-center">
                    <b-col cols='10'>
                        <b-row class="align-items-center">
                            <b-col>
                                <lg-form-input class="mt-3" v-model="pesquisa" label=" "></lg-form-input>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols='2' class='d-flex justify-content-center align-items-center'>
                        <b-button id="localizar" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                            @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                                <b-tooltip target="localizar" title="Localizar" triggers="hover"></b-tooltip>
                            </div>
                        </b-button>
                        <b-button id="Limpar" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                            @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="Limpar" title="Limpar" triggers="hover"></b-tooltip>
                        </b-button>
                        <b-button id="novo" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            @click="showModalNovaRequisicao" variant="primary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="nova" title="Adicionar nova..." triggers="hover"></b-tooltip>
                        </b-button>
                    </b-col>
                </b-row>
            </b-card>
            <b-card bg-variant="light" class="mt-3">
                <b-table responsive show-empty class="mt-2" small :busy="busy" :items="records" :fields="fields" hover
                    @row-dblclicked="onDblClickRequisicao">
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(dataOficio)="data">
                        <span v-if="data.item.dataOficio">
                            {{ formatDate(data.item.dataOficio) }}
                        </span>
                        <span v-else>
                            N/A
                        </span>
                    </template>
                    <template v-slot:cell(edit)="data">
                        <b-button v-if="data.item.status === StatusEnum.REQUISICAO_COMPRA_EM_ANDAMENTO.value"
                            :id="data.index + 'edit-button'" class="my-2 mx-1" size="sm" pill variant="primary"
                            @click="editar(data.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="data.index + 'edit-button'" title="Editar"></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(status)="data">
                        <b-badge :variant="badgeVariant(data.item.status)" class="badge">
                            {{ formatSituacao(data.item.status) }}
                        </b-badge>
                    </template>
                    <template v-slot:cell(visualizar)="data">

                        <b-button :id="data.index + 'visualizar-button'" class="my-2 mx-1" size="sm" pill
                            variant="primary" @click="visualizar(data.item)">
                            <b-icon icon="eye" />
                            <b-tooltip :target="data.index + 'visualizar-button'" title="Visualizar"></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(aprove)="data">
                        <b-button v-if="data.item.status === StatusEnum.REQUISICAO_COMPRA_EM_ANDAMENTO.value"
                            :id="data.index + 'approve-button'" class="my-2 mx-1" size="sm" pill variant="success"
                            @click="alterarStatus(data.item.id, StatusEnum.REQUISICAO_COMPRA_APROVADO.value)">
                            <b-icon icon="check-circle" />
                            <b-tooltip :target="data.index + 'approve-button'" title="Aprovar"></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(reject)="data">
                        <b-button v-if="data.item.status === StatusEnum.REQUISICAO_COMPRA_EM_ANDAMENTO.value"
                            :id="data.index + 'reject-button'" class="my-2 mx-1" size="sm" pill variant="danger"
                            @click="alterarStatus(data.item.id, StatusEnum.REQUISICAO_COMPRA_REJEITADO.value)">
                            <b-icon icon="x-circle" />
                            <b-tooltip :target="data.index + 'reject-button'" title="Rejeitar"></b-tooltip>
                        </b-button>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
            <b-modal @hidden="fecharModalNovaRequisicao" ref="modalNovaRequisicao" size="xl" hide-footer
                :title="prefix + title + ' > Cadastrar'">
                <ConsultarRequisicoesForm :ata="ata" :prefix="[prefix + title]" :idRequisicao="selectedRequisicaoId"
                    :isViewMode="isViewMode" @submit="load" @close='fecharModalNovaRequisicao' />
            </b-modal>
        </b-card-body>

    </b-card>
</template>

<script>
import ConsultarRequisicoesForm from "./ConsultarRequisicoesForm.vue"
import RequisicaoCompraService from "@/core/api/RequisicaoCompraService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import StatusEnum from "@/core/utils/StatusEnum"
import Swal from "sweetalert2"
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource";

export default {
    components: {
        ConsultarRequisicoesForm,
        LgFormInput,

    },
    mixins: [ListResourceMixin],

    props: {
        prefix: {
            type: String,
            default: ""
        },
        ata: {
            type: Number,
            default: null,
        },
        onlyAproved: {
            type: Boolean,
            default: false
        },
    },
    name: "ConsultarRequisicaoCompra",
    data() {
        return {
            pesquisa: "",
            title: "Consultar Requisições de Compra",
            selectedRequisicaoId: null,
            fields: [
                { key: "numeroRequisicaoCompra", label: "Nº da Requisição" },
                { key: "tipoRequisicaoCompra", label: "Tipo Requisição" },
                { key: "grupoProduto", label: "Tipo Compra" },

                { key: "dataOficio", label: "Data Documento" },
                { key: "departamento", label: "Departamento" },
                { key: "status", label: "Status" },
                {
                    key: "visualizar", label: "", tdClass: ["w-1", "text-center"],
                },

                {
                    key: "edit", label: "", tdClass: ["w-1", "text-center"],
                },
                {
                    key: "aprove", label: "", tdClass: ["w-1", "text-center"],
                },
                {
                    key: "reject", label: "", tdClass: ["w-1", "text-center"],
                },

            ],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 1,
            busy: false,
            perPageOptions: [5, 10, 25, 50],
            isViewMode: false,
            selectedRequisicaoNumero: null,
            action: '',
            StatusEnum,
        }
    },
    watch: {
        page() {
            this.load()
        },
    },

    beforeMount() {
        this.$service = new ResourceService(`/api/requisicoes-compra`);
        this.load()
    },
    methods: {

        async load() {
            this.busy = true
            this.filtro = {};
            if (this.pesquisa)
                this.filtro.pesquisa = this.pesquisa;


            if (this.ata) {
                this.filtro.ata = this.ata;
            }

            if (this.onlyAproved) {
                this.filtro.onlyAproved = true;
            }

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

        },
        showModalNovaRequisicao() {
            this.$refs.modalNovaRequisicao.show()
        },
        fecharModalNovaRequisicao() {
            this.$refs.modalNovaRequisicao.hide()
            this.selectedRequisicaoId = null
            this.isViewMode = false
            this.load()
        },
        editar(requisicao) {
            this.selectedRequisicaoId = requisicao.id
            this.$refs.modalNovaRequisicao.show()
        },
        visualizar(requisicao) {
            this.selectedRequisicaoId = requisicao.id
            this.isViewMode = true
            this.$refs.modalNovaRequisicao.show()
        },
        async alterarStatus(id, statusId) {
            const action = statusId === StatusEnum.REQUISICAO_COMPRA_APROVADO.value ? 'aprovar' : 'rejeitar'
            const result = await Swal.fire({
                title: 'Você tem certeza?',
                text: `Deseja ${action} esta requisição de compra?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Sim',
                cancelButtonColor: '#d33',
            })

            if (result.isConfirmed) {
                try {
                    await RequisicaoCompraService.updateStatus(id, statusId)
                    this.load()
                    Swal.fire(`${action.charAt(0).toUpperCase() + action.slice(1)}!`, `A requisição de compra foi ${action}ada.`, 'success')
                } catch (error) {
                    console.error(`Erro ao ${action} a requisição:`, error)
                    Swal.fire('Erro!', `Ocorreu um erro ao ${action} a requisição de compra.`, 'error')
                }
            }
        },
        confirmarAcao() {
            RequisicaoCompraService.updateStatus(this.selectedRequisicaoId, this.action === 'aprovar' ? StatusEnum.REQUISICAO_COMPRA_APROVADO.value : StatusEnum.REQUISICAO_COMPRA_REJEITADO.value)
                .then(() => {
                    this.load()
                })
                .catch(() => {
                })
            this.fecharConfirmModal()
        },
        fecharConfirmModal() {
            this.$refs.confirmModal.hide()
            this.selectedRequisicaoId = null
            this.selectedRequisicaoNumero = null
        },
        formatSituacao(situacao) {
            return StatusEnum.fromValue(situacao).descricao || "N/A"
        },
        badgeVariant(situacao) {
            const variants = {
                [StatusEnum.REQUISICAO_COMPRA_EM_ANDAMENTO.value]: "primary",
                [StatusEnum.REQUISICAO_COMPRA_APROVADO.value]: "success",
                [StatusEnum.REQUISICAO_COMPRA_REJEITADO.value]: "danger",
            }
            return variants[situacao] || "secondary"
        },
        clearForm() {
            this.pesquisa = ''
            this.load()
        },
        onDblClickRequisicao(item) {
            this.$emit('onDblClickRequisicao', item)
        },
        formatDate(dateString) {
            if (!dateString) return "N/A"
            const [year, month, day] = dateString.split("-")
            return `${day}/${month}/${year}`
        },
    },
}
</script>

<style scoped>
.badge {
    font-size: 85% !important;
    padding: 5px 10px !important;
}

.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
